import { render, staticRenderFns } from "./FilterProducts.vue?vue&type=template&id=fc1d0fac&scoped=true&"
import script from "./FilterProducts.vue?vue&type=script&lang=js&"
export * from "./FilterProducts.vue?vue&type=script&lang=js&"
import style0 from "./FilterProducts.vue?vue&type=style&index=0&id=fc1d0fac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1d0fac",
  null
  
)

export default component.exports